export const radii = { none: 0, sm: 3, md: 3, lg: 3, card: 6, pill: 999 } as const;

export type RadiusToken = keyof typeof radii;

export const r = (token: RadiusToken): string => `${radii[token]}px`;
